/**
* RelytArt
*
* Creative Commons Attribution-NonCommercial-NoDerivatives 4.0 International
* Copyright (c) 2022 RelytArt
*
* License: https://docs.google.com/document/d/1UD7jhCYWRXSxhx4A5vMeGVTjujwLM39BmvjwA0eFFfk/edit?usp=sharing
*
*/

// node_modules
import React, { Component } from "react";

// components - atoms
import LoadingSpinner from "components/atoms/LoadingSpinner/LoadingSpinner.js";

class Page extends Component {
  constructor(props) {
    super(props);
    // @props: fluid - Boolean
    // @props: isLoading - Boolean

    this.state = {};
  }

  render() {
    const { props } = this;
    const { fluid, isLoading } = props;
    const widthConstraint = Math.min(window.innerWidth, window.outerWidth);

    return (
      <main
        className={props.className || `container-${fluid ? "fluid" : "xl"}`}
        id={"content"}
        role={"main"}
        style={{
          maxWidth: widthConstraint,
          position: "relative",
          ...props.style
        }}
      >
        {/* Loading */}
        {isLoading && (
          <div className={"d-flex mt-5"}>
            <LoadingSpinner />
          </div>
        )}

        {/* Children */}
        {!isLoading && props.children}
      </main>
    );
  }
}
export default Page;
